/**
 * @fileoverview SingleClickBlurStepIndicator Component - Single Click Blur Progress
 *
 * This component displays the Single Click Blur progress indicator,
 * replacing the standard step indicator during Single Click Blur operations.
 *
 * @description
 * Key features:
 * - Shows processing state with spinner
 * - Shows complete state with checkmark
 * - Simple single-step display
 *
 * @requires React
 */
import React from 'react';

/**
 * SingleClickBlurStepIndicator Component
 *
 * @param {Object} props
 * @param {boolean} props.isComplete - Whether processing is complete
 * @returns {JSX.Element}
 */
function SingleClickBlurStepIndicator({ isComplete }) {
  return (
    <div className="flex items-center justify-center mb-4">
      <div className={`flex items-center gap-2 px-4 py-2 rounded-full transition-all ${
        isComplete
          ? 'bg-green-500/20 border border-green-500/50 text-green-400'
          : 'bg-purple-500/20 border border-purple-500 text-white'
      }`}>
        <span className={`w-6 h-6 rounded-full flex items-center justify-center ${
          isComplete ? 'bg-green-500 text-white' : 'bg-purple-500 text-white'
        }`}>
          {isComplete ? (
            <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M5 13l4 4L19 7" />
            </svg>
          ) : (
            <svg className="w-4 h-4 animate-spin" fill="none" viewBox="0 0 24 24">
              <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
              <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z" />
            </svg>
          )}
        </span>
        <span className="font-medium">Single Click Blur</span>
      </div>
    </div>
  );
}

export default SingleClickBlurStepIndicator;
